export const definitions = {
    BravuraText: {
        quaternary: [
            {
                family: 'Bravura Text',
                source: '/fonts/BravuraText/BravuraText-1.393.woff2'
                // Note: As discovered for DS issue 2895, we can't set "unicodeRange" to the
                // required value specified by the font designers. If we do, the font face
                // definition isn't accepted by browsers.
                // https://github.com/steinbergmedia/bravura/blob/a7ba777c9c601c229ad95eee01ee985f281bd57b/redist/bravura-text.md#glyph-repertoire
                // descriptors: {
                //     unicodeRange: 'U+E000-U+FFFF'
                // }
            }
        ]
    },

    FontAwesome: {
        secondary: [
            {
                family: 'FontAwesome',
                source: '/fonts/FontAwesome/fontawesome-4.7.0.woff2'
            }
        ]
    },

    Skolar: {
        primary: [
            {
                family: 'Skolar',
                source: '/fonts/Skolar/Skolar.woff2'
            }
        ],
        tertiary: [
            {
                family: 'Skolar',
                source: '/fonts/Skolar/Skolar-Italic.woff2',
                descriptors: {style: 'italic'}
            },
            {
                family: 'Skolar',
                source: '/fonts/Skolar/Skolar-Light.woff2',
                descriptors: {weight: '300'}
            },
            {
                family: 'Skolar',
                source: '/fonts/Skolar/Skolar-LightItalic.woff2',
                descriptors: {style: 'italic', weight: '300'}
            },
            {
                family: 'Skolar',
                source: '/fonts/Skolar/Skolar-Semibold.woff2',
                descriptors: {weight: 'bold'}
            },
            {
                family: 'Skolar',
                source: '/fonts/Skolar/Skolar-Semibold-Italic.woff2',
                descriptors: {style: 'italic', weight: 'bold'}
            }
        ]
    },

    SkolarSans: {
        primary: [
            {
                family: 'SkolarSans',
                source: '/fonts/SkolarSans/SkolarSans.woff2'
            }
        ],
        tertiary: [
            {
                family: 'SkolarSans',
                source: '/fonts/SkolarSans/SkolarSans-Italic.woff2',
                descriptors: {style: 'italic'}
            },
            {
                family: 'SkolarSans',
                source: '/fonts/SkolarSans/SkolarSans-Semibold.woff2',
                descriptors: {weight: 'bold'}
            },
            {
                family: 'SkolarSans',
                source: '/fonts/SkolarSans/SkolarSans-Semibold-Italic.woff2',
                descriptors: {style: 'italic', weight: 'bold'}
            }
        ]
    },

    Metropolis: {
        primary: [
            {
                family: 'Metropolis',
                source: '/fonts/Metropolis/Metropolis-Regular.woff2'
            }
        ],
        tertiary: [
            {
                family: 'Metropolis',
                source: '/fonts/Metropolis/Metropolis-Bold.woff2',
                descriptors: {weight: '700'}
            },
            {
                family: 'Metropolis',
                source: '/fonts/Metropolis/Metropolis-BoldItalic.woff2',
                descriptors: {weight: '700', style: 'italic'}
            },
            {
                family: 'Metropolis',
                source: '/fonts/Metropolis/Metropolis-Medium.woff2',
                descriptors: {weight: '500'}
            },
            {
                family: 'Metropolis',
                source: '/fonts/Metropolis/Metropolis-MediumItalic.woff2',
                descriptors: {weight: '500', style: 'italic'}
            },
            {
                family: 'Metropolis',
                source: '/fonts/Metropolis/Metropolis-RegularItalic.woff2',
                descriptors: {style: '400'}
            }
        ]
    },

    Garamond: {
        primary: [
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR1SDk.woff2',
                descriptors: {
                    weight: '400',
                    unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD'
                }
            }
        ],
        // There are a LOT of tertiary and quaternary files because Google Fonts
        // divided different Unicode ranges into different files, to reduce
        // loading time. For the Egret DS, we only definitely need the Latin and
        // Latin-extended character ranges, so we'll load them as tertiary.
        // The other character ranges are defined as quaternary, allowing the
        // browser to decide when to actually load the files.
        tertiary: [
            // latin
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR1SDk.woff2',
                descriptors: {
                    style: 'normal',
                    weight: '700',
                    unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDs1Zw.woff2',
                descriptors: {
                    style: 'italic',
                    weight: '700',
                    unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDs1Zw.woff2',
                descriptors: {
                    style: 'italic',
                    weight: '400',
                    unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD'
                }
            },
            // latin-ext
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR7SDktYw.woff2',
                descriptors: {
                    style: 'normal',
                    weight: '700',
                    unicodeRange: 'U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR7SDktYw.woff2',
                descriptors: {
                    style: 'normal',
                    weight: '400',
                    unicodeRange: 'U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDU1ZzPJ.woff2',
                descriptors: {
                    style: 'italic',
                    weight: '700',
                    unicodeRange: 'U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDU1ZzPJ.woff2',
                descriptors: {
                    style: 'italic',
                    weight: '400',
                    unicodeRange: 'U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF'
                }
            }
        ],
        quaternary: [
            // cyrillic
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweD81ZzPJ.woff2',
                descriptors: {
                    style: 'italic',
                    weight: '400',
                    unicodeRange: 'U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweD81ZzPJ.woff2',
                descriptors: {
                    style: 'italic',
                    weight: '700',
                    unicodeRange: 'U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GRxSDktYw.woff2',
                descriptors: {
                    style: 'normal',
                    weight: '400',
                    unicodeRange: 'U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GRxSDktYw.woff2',
                descriptors: {
                    style: 'normal',
                    weight: '700',
                    unicodeRange: 'U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116'
                }
            },
            // cyrillic-ext
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDY1ZzPJ.woff2',
                descriptors: {
                    style: 'italic',
                    weight: '400',
                    unicodeRange: 'U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDY1ZzPJ.woff2',
                descriptors: {
                    style: 'italic',
                    weight: '700',
                    unicodeRange: 'U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR4SDktYw.woff2',
                descriptors: {
                    style: 'normal',
                    weight: '400',
                    unicodeRange: 'U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR4SDktYw.woff2',
                descriptors: {
                    style: 'normal',
                    weight: '700',
                    unicodeRange: 'U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F'
                }
            },
            // greek
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDg1ZzPJ.woff2',
                descriptors: {
                    style: 'italic',
                    weight: '400',
                    unicodeRange: 'U+0370-03FF'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDg1ZzPJ.woff2',
                descriptors: {
                    style: 'italic',
                    weight: '700',
                    unicodeRange: 'U+0370-03FF'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR2SDktYw.woff2',
                descriptors: {
                    style: 'normal',
                    weight: '400',
                    unicodeRange: 'U+0370-03FF'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR2SDktYw.woff2',
                descriptors: {
                    style: 'normal',
                    weight: '700',
                    unicodeRange: 'U+0370-03FF'
                }
            },
            // greek-ext
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDc1ZzPJ.woff2',
                descriptors: {
                    style: 'italic',
                    weight: '400',
                    unicodeRange: 'U+1F00-1FFF'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDc1ZzPJ.woff2',
                descriptors: {
                    style: 'italic',
                    weight: '700',
                    unicodeRange: 'U+1F00-1FFF'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR5SDktYw.woff2',
                descriptors: {
                    style: 'normal',
                    weight: '400',
                    unicodeRange: 'U+1F00-1FFF'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR5SDktYw.woff2',
                descriptors: {
                    style: 'normal',
                    weight: '700',
                    unicodeRange: 'U+1F00-1FFF'
                }
            },
            // vietnamese
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDQ1ZzPJ.woff2',
                descriptors: {
                    style: 'italic',
                    weight: '400',
                    unicodeRange: 'U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDQ1ZzPJ.woff2',
                descriptors: {
                    style: 'italic',
                    weight: '700',
                    unicodeRange: 'U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR6SDktYw.woff2',
                descriptors: {
                    style: 'normal',
                    weight: '400',
                    unicodeRange: 'U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB'
                }
            },
            {
                family: 'EB Garamond',
                source: '/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR6SDktYw.woff2',
                descriptors: {
                    style: 'normal',
                    weight: '700',
                    unicodeRange: 'U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB'
                }
            }
        ]
    }
};
